const lerp = (a, b, n) => (1 - n) * a + n * b;
const getMousePos = event => {
    return {
        x: event.clientX,
        y: event.clientY,
    };
};

function copyright() {
    console.log('%cDesign & Code - https://laroutourne.studio', 'background: #000; border: 2px solid #fff; padding: 15px; color: #fff; font-size: .8rem;');
}

// const screens = {
//     intro: document.querySelector('#block-intro'),
//     hero: document.querySelector('#block-hero'),
//     drawing: document.querySelector('#block-drawing'),
//     prediction: document.querySelector('#block-prediction'),
//     cards: document.querySelector('#block-cards'),
//     transitions: document.querySelector('#block-transitions'),
//     transition1: document.querySelector('#block-transition-1'),
//     transition2: document.querySelector('#block-transition-2'),
//     transition3: document.querySelector('#block-transition-3'),
//     transition4: document.querySelector('#block-transition-4'),
// };

// function transition(from, to, side) {
//     screens.transitions.classList.remove('hide');

//     if (side) {
//         screens.transitions.classList.add(side);
//     }

//     setTimeout(() => {
//         screens.transitions.classList.add('start');
//     }, 0);

//     setTimeout(() => {
//         from.classList.add('hide');
//         to.classList.remove('hide');
//     }, 450);

//     setTimeout(() => {
//         screens.transitions.classList.remove('start');
//     }, 2000);

//     setTimeout(() => {
//         screens.transitions.classList.add('hide');

//         if (side) {
//             screens.transitions.classList.remove(side);
//         }
//     }, 2100);
// }

function calcWinsize() {
    return {width: window.innerWidth, height: window.innerHeight};
};

// function sendAjax() {
//     const request = new XMLHttpRequest();
//     const url = ParamsData.wp_ajax_url;
//     const ajaxData = new FormData();

//     ajaxData.append('action', 'get_data');
//     ajaxData.append('nonce', ParamsData.nonce);

//     request.open('POST', url, true);
//     request.send(ajaxData);
//     request.onprogress = () => console.log('onprogress...');

//     request.onload = () => {
//         let response = request.response;

//         if (typeof response === 'string') {
//             response = JSON.parse(response);
//         }

//         console.log('sendAjax', response);
//         ParamsData.deck = response;
//     };

//     request.onerror = () => console.log('onerror...');
// }

function distance(x1,y1,x2,y2) {
    var a = x1 - x2;
    var b = y1 - y2;

    return Math.hypot(a,b);
}

export {lerp, getMousePos, calcWinsize, distance, copyright};
